


export default class GlobalService {
    public query: string = "";
    public mode = false;

    public setQuery(query: string) {
        this.query = query;
    }

    public setMode(mode: boolean) {
        this.mode = mode;
    }


}
